export default __webpack_public_path__ + "static/media/recent_transactions_icon.61ca775f.svg";